/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 10/3/2022
 */

import {QwoachFileType} from "@shared/Drive/QwoachFileType.js";

function toQwoachFileType(dbObjectType){
	switch (dbObjectType) {
		case DbObjectType.FORM_ITEM:
			return QwoachFileType.FORM
		case DbObjectType.LEGAL_DOC:
			return QwoachFileType.LEGAL_DOC_TEMPLATE
		default:
			console.error("Unknown DbObjectType", this)
	}
}


export const DbObjectType = Object.freeze({
	FORM_ITEM: "FORM_ITEM",
	LEGAL_DOC: "LEGAL_DOC",

})

export {
	toQwoachFileType
}
